import { URL_PREFIX } from '../constants/api';

export interface RelatedTrack {
  isrc: string;
  title: string;
  version?: string;
  majorLabels?: string[];
  audioPresentation: string | null;
  recType?: string;
  recSubType?: string;
  mediaCode?: string;
  paFlag: boolean;
  isTwin: boolean;
}

/**
 * Temporary fix for incorrect data structure in audioPresentation.
 */
export const escapeAudioPresentation = (
  audioPresentation = '',
): string | null => {
  let audioPres: string | undefined = audioPresentation;

  try {
    const audioPresentations = JSON.parse(audioPresentation) as string[];

    audioPres = audioPresentations[0];
  } catch {
    // silently ignore
  }

  if (!audioPres || audioPres === '') {
    return null;
  }

  return audioPres;
};

export async function getRelatedTracks(isrc: string): Promise<RelatedTrack[]> {
  try {
    const response = await fetch(
      `${URL_PREFIX}/api/v1/dashboard/related-tracks/${isrc}`,
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch related tracks: ${response.statusText}`);
    }

    const raw = (await response.json()) as {
      isrc: string;
      track_title: string;
      track_version?: string;
      major_labels?: string[];
      audio_presentation: string;
      rec_type?: string;
      rec_sub_type?: string;
      media_code?: string;
      pa_flag: boolean;
      is_twin: boolean;
    }[];

    return raw.map((item) => ({
      isrc: item.isrc,
      title: item.track_title,
      version: item.track_version,
      majorLabels: item.major_labels ?? [],
      audioPresentation: escapeAudioPresentation(item.audio_presentation),
      recType: item.rec_type,
      recSubType: item.rec_sub_type,
      mediaCode: item.media_code,
      paFlag: item.pa_flag,
      isTwin: item.is_twin,
    }));
  } catch (error) {
    console.error('getRelatedTracks error:', error);

    throw error;
  }
}
